import { Routes } from '@angular/router';

export const routes: Routes = [];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/user/user.routes.ts